//==============================================
// Block: Home Hero
//==============================================

var initBlockBgImgContent = function( $block ) {
    
    let blockheader= $block.find('.block-icon-columns__title');
    let blockIconCell = $block.find('.block-icon-columns__cell');
    let blockIconCTA = $block.find('.block-icon-columns__cta');

    let blockIconColInit = gsap.timeline({
        scrollTrigger: {
            trigger: $block,
            start: 'top 80%',
            //markers: true,
        },
    });

    blockIconColInit.from(blockheader, {
        duration: 1,
        ease: "power1.out",
        opacity: '0'
    })
    .staggerFrom(blockIconCell, 1, {
        ease: "power1.out",
        marginTop: '8rem',
        opacity: '0'
    }, 0.2)
    .from(blockIconCTA, {
        duration: 1,
        ease: "power1.out",
        opacity: '0'
    });
    

};


// Initialize each block on page load (front end).
$(document).ready(function(){
    $('.block-icon-columns').each(function(){
        initBlockBgImgContent( $(this) );
    });
});

/* if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=block-icon-columns', initBlockBgImgContent );
} */